<template>
  <div class="steps-fcbecf18" v-bind:class="{ 'translate-y': translate }">
    <div class="container">
      <div class="row align-items-center justify-content-center">
        <div class="col-md-6">
          <div class="steps-ui">
            <div class="steps text-center">
              <span>{{ active }}</span
              ><span> / </span><span>{{ acf.total }}</span>
            </div>
            <div
              class="marker"
              v-bind:style="{
                width: `${width}px`,
                transform: `translate(${width * active - width}px, 5px)`,
              }"
            ></div>
            <div class="rail" ref="rail">
              <!--  -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "steps-fcbecf18",
  props: ["acf", "translate"],
  data() {
    return {
      width: undefined,
    };
  },
  computed: {
    active() {
      return this.acf.next ? `0${this.acf.next - 1}` : this.acf.total;
    },
  },
  watch: {
    "$root.mode": {
      handler(arg) {
        this.$nextTick(() => {
          this.width =
            this.$refs.rail.getBoundingClientRect().width / this.acf.total;
        });
      },
      immediate: true,
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";
@import "../../css/components/modal";

.steps-fcbecf18 {
  padding-top: 2rem;

  &.translate-y {
    transform: translateY(-3rem);
  }

  .steps-ui {
    .rail {
      height: 3px;
      border-radius: 6px;
      background-color: rgba($cc-resmed-grey-30, 0.75);
    }

    .marker {
      height: 7px;
      border-radius: 12px;
      background-color: $cc-resmed-grey-50;
      // transform: translateY(5px);
    }

    .steps {
      font-family: "Plus Jakarta Sans", sans-serif;
      font-weight: 700;
      color: $cc-resmed-grey-30;
      margin-bottom: 1rem;

      span {
        &:nth-child(1) {
          font-size: 1.313rem;
          color: $cc-resmed-grey-50;
        }

        &:nth-child(2),
        &:nth-child(3) {
          display: inline-block;
          font-size: 0.875em;
          transform: translateY(-0.25rem);
        }
      }
    }
  }
}
</style>